import AddBadge from "atoms/badges/add-badge";
import Button, { ButtonTypes } from "atoms/buttons/button";
import { ButtonStyles } from "atoms/constants/button-styles";
import Icon from "atoms/icons/icon";
import {
    NotebookPageContentBlock,
    NotebookPageContentBlockCultureCode,
    NotebookPageContentBlockIcon,
} from "constants/notebooks/notebook-page-content-blocks";
import React from "react";
import { t } from "utilities/localization-utils";

const CSS_CLASS_NAME = "c-notebook-page-content-block-button";

interface NotebookPageContentBlockTypeButtonProps {
    type: NotebookPageContentBlock;
    style?: ButtonStyles;
    onClick: (type: NotebookPageContentBlock) => void;
    disabled?: boolean;
}

const NotebookPageContentBlockTypeButton = ({
    type,
    onClick,
    style = ButtonStyles.Tertiary,
    disabled = false,
}: NotebookPageContentBlockTypeButtonProps) => {
    return (
        <Button
            type={ButtonTypes.Button}
            disabled={disabled}
            style={style}
            onClick={() => {
                onClick(type);
            }}
            cssClassName={CSS_CLASS_NAME}>
            <Icon
                cssClassName={`${CSS_CLASS_NAME}__icon`}
                type={NotebookPageContentBlockIcon[type]}
            />
            <span className={`${CSS_CLASS_NAME}__text`}>
                {t(NotebookPageContentBlockCultureCode[type])}
            </span>
            <span className={`${CSS_CLASS_NAME}__addButton`}>
                <AddBadge />
            </span>
        </Button>
    );
};

export default NotebookPageContentBlockTypeButton;
